/* Rosselle Studio AI Chat Widget v2.0 */
(function (global) {
  'use strict';

  /* ─── Configuration ─────────────────────────────────────────── */
  var CFG = {
    webhookUrl:       global.ROSSELLE_WEBHOOK_URL || '',
    widgetToken:      global.ROSSELLE_WIDGET_TOKEN || '',
    brandName:        'Rosselle Studio',
    supportEmail:     'info@rossellestudio.com',
    supportInstagram: '@rossellestudio',
    rateLimit:        { max: 10, windowMs: 120000 },
    timeoutMs:        30000,
    maxHistory:       20,
    quickReplies: [
      'Track my order',
      'Size guide',
      'Shipping info',
      'New arrivals'
    ],
    welcomeMessage: '**Welcome to Rosselle Studio** 🤍\n\nI\'m your personal shopping assistant. I can help with:\n\n• Products & sizing\n• Shipping & delivery\n• Order tracking\n• Style advice\n\nHow can I help you today?'
  };

  /* ─── Utilities ─────────────────────────────────────────────── */
  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function fmtTime(d) {
    d = d || new Date();
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  function uid() {
    return 'rw_' + Math.random().toString(36).slice(2, 11) + '_' + Date.now();
  }

  /* ─── Markdown Renderer ─────────────────────────────────────── */
  function applyInline(text) {
    // Bold: **text**
    text = text.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    // Bold: __text__
    text = text.replace(/__(.+?)__/g, '<strong>$1</strong>');
    // Italic: *text* (after bold so ** is already consumed)
    text = text.replace(/\*([^\*\n]+)\*/g, '<em>$1</em>');
    // Inline code: `code`
    text = text.replace(/`([^`\n]+)`/g, '<code class="rw-md-code">$1</code>');
    // Links: [text](https://...) — https only
    text = text.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g,
      '<a href="$2" target="_blank" rel="noopener noreferrer" class="rw-md-link">$1</a>');
    return text;
  }

  function renderMarkdown(raw) {
    if (!raw) return '';

    // Step 1 — escape HTML entities (XSS safety)
    var safe = escHtml(raw);

    // Step 2 — process line by line
    var lines = safe.split('\n');
    var out   = [];
    var i     = 0;

    while (i < lines.length) {
      var line = lines[i].trim();

      // Headings: # ## ###
      var hm = line.match(/^(#{1,3})\s+(.+)$/);
      if (hm) {
        var lvl = Math.min(hm[1].length + 1, 4);
        out.push('<h' + lvl + ' class="rw-md-h">' + applyInline(hm[2]) + '</h' + lvl + '>');
        i++; continue;
      }

      // Bullet list — collect consecutive bullet lines
      if (/^[•\-\*]\s/.test(line)) {
        var lis = [];
        while (i < lines.length && /^[•\-\*]\s/.test(lines[i].trim())) {
          lis.push('<li>' + applyInline(lines[i].trim().replace(/^[•\-\*]\s+/, '')) + '</li>');
          i++;
        }
        out.push('<ul class="rw-md-ul">' + lis.join('') + '</ul>');
        continue;
      }

      // Numbered list — collect consecutive numbered lines
      if (/^\d+\.\s/.test(line)) {
        var ols = [];
        while (i < lines.length && /^\d+\.\s/.test(lines[i].trim())) {
          ols.push('<li>' + applyInline(lines[i].trim().replace(/^\d+\.\s+/, '')) + '</li>');
          i++;
        }
        out.push('<ol class="rw-md-ol">' + ols.join('') + '</ol>');
        continue;
      }

      // Empty line — paragraph gap
      if (!line) {
        out.push('<div class="rw-md-gap"></div>');
        i++; continue;
      }

      // Regular paragraph
      out.push('<p class="rw-md-p">' + applyInline(line) + '</p>');
      i++;
    }

    return out.join('');
  }

  /* ─── Rate Limiter ──────────────────────────────────────────── */
  function RateLimiter(max, windowMs) {
    this.max = max;
    this.win = windowMs;
    this.log = [];
  }
  RateLimiter.prototype.check = function () {
    var now = Date.now();
    this.log = this.log.filter(function (t) { return now - t < this.win; }, this);
    if (this.log.length >= this.max) return false;
    this.log.push(now);
    return true;
  };
  RateLimiter.prototype.wait = function () {
    if (!this.log.length) return 0;
    return Math.ceil((this.win - (Date.now() - this.log[0])) / 1000);
  };

  /* ─── Session ───────────────────────────────────────────────── */
  var Session = {
    KEY: 'rw_session',
    get: function () {
      try {
        var raw = sessionStorage.getItem(this.KEY);
        if (raw) return JSON.parse(raw);
      } catch (_) {}
      return { id: uid(), history: [] };
    },
    save: function (s) {
      try {
        if (s.history.length > CFG.maxHistory) s.history = s.history.slice(-CFG.maxHistory);
        sessionStorage.setItem(this.KEY, JSON.stringify(s));
      } catch (_) {}
    }
  };

  /* ─── SVG Icons ─────────────────────────────────────────────── */
  var ICONS = {
    chat:  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>',
    close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>',
    minus: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13H5v-2h14v2z"/></svg>',
    send:  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>',
    img:   '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/></svg>',
    email: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>',
    ig:    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>'
  };

  /* ─── Widget Template ───────────────────────────────────────── */
  function buildTemplate() {
    return [
      '<button class="rw-fab" id="rw-fab" aria-label="Open chat" title="Chat with Rosselle Studio">',
        '<span class="rw-fab-icon rw-fab-icon--chat">' + ICONS.chat + '</span>',
        '<span class="rw-fab-icon rw-fab-icon--close">' + ICONS.close + '</span>',
        '<span class="rw-badge" id="rw-badge" style="display:none">1</span>',
      '</button>',
      '<div class="rw-window" id="rw-window" role="dialog" aria-modal="true" aria-label="Rosselle Studio Chat">',
        '<div class="rw-header">',
          '<div class="rw-avatar">RS</div>',
          '<div class="rw-header-info">',
            '<div class="rw-brand-name">Rosselle Studio</div>',
            '<div class="rw-status">Online &middot; Here to help</div>',
          '</div>',
          '<div class="rw-header-btns">',
            '<button class="rw-icon-btn" id="rw-minimize" title="Minimise" aria-label="Minimise">' + ICONS.minus + '</button>',
            '<button class="rw-icon-btn" id="rw-close-btn" title="Close" aria-label="Close">' + ICONS.close + '</button>',
          '</div>',
        '</div>',
        '<div class="rw-body" id="rw-body" role="log" aria-live="polite" aria-label="Chat messages">',
          '<div class="rw-divider">Today</div>',
        '</div>',
        '<div class="rw-input-zone">',
          '<div class="rw-input-wrap">',
            '<textarea class="rw-textarea" id="rw-textarea" rows="1" placeholder="Ask me anything…" maxlength="1000" aria-label="Type your message"></textarea>',
            '<button class="rw-send" id="rw-send" disabled title="Send" aria-label="Send">' + ICONS.send + '</button>',
          '</div>',
        '</div>',
        '<div class="rw-footer">Powered by <strong>Rosselle Studio AI</strong> &nbsp;&middot;&nbsp; <a href="mailto:' + CFG.supportEmail + '">Get help</a></div>',
      '</div>'
    ].join('');
  }

  /* ─── Product Cards ─────────────────────────────────────────── */
  function renderProductCards(products) {
    if (!products || !products.length) return '';
    var cards = products.slice(0, 3).map(function (p) {
      var img = p.image
        ? '<img class="rw-product-img" src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" loading="lazy">'
        : '<div class="rw-product-img-ph">' + ICONS.img + '</div>';
      var inStock = p.available !== false;
      return [
        '<a href="' + escHtml(p.url || '#') + '" class="rw-product-card" target="_blank" rel="noopener noreferrer">',
          img,
          '<div class="rw-product-meta">',
            '<div class="rw-product-name">' + escHtml(p.title) + '</div>',
            '<div class="rw-product-price">' + escHtml(p.price || '') + '</div>',
            '<div class="rw-product-stock rw-product-stock--' + (inStock ? 'in' : 'out') + '">',
              (inStock ? '● In Stock' : '○ Sold Out'),
            '</div>',
          '</div>',
        '</a>'
      ].join('');
    });
    return '<div class="rw-products">' + cards.join('') + '</div>';
  }

  /* ─── Escalation Panel ──────────────────────────────────────── */
  function renderEscalation() {
    return [
      '<div class="rw-escalation">',
        '<div class="rw-escalation-title">Our team is here for you</div>',
        '<div class="rw-escalation-links">',
          '<a href="mailto:' + CFG.supportEmail + '" class="rw-escalation-link">',
            ICONS.email,
            '<span>' + CFG.supportEmail + '</span>',
          '</a>',
          '<a href="https://instagram.com/rossellestudio" target="_blank" rel="noopener" class="rw-escalation-link">',
            ICONS.ig,
            '<span>' + CFG.supportInstagram + '</span>',
          '</a>',
        '</div>',
      '</div>'
    ].join('');
  }

  /* ─── Widget Class ──────────────────────────────────────────── */
  function RosselleWidget() {
    this.open      = false;
    this.minimized = false;
    this.busy      = false;
    this.welcomed  = false;
    this.rl        = new RateLimiter(CFG.rateLimit.max, CFG.rateLimit.windowMs);
    this.session   = Session.get();
    this._setup();
  }

  RosselleWidget.prototype._setup = function () {
    this._injectFonts();
    this._mount();
    this._bind();
    var badge = document.getElementById('rw-badge');
    if (badge) setTimeout(function () { badge.style.display = 'flex'; }, 2000);
  };

  RosselleWidget.prototype._injectFonts = function () {
    if (document.getElementById('rw-fonts')) return;
    var l = document.createElement('link');
    l.id  = 'rw-fonts';
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600&family=Inter:wght@300;400;500;600&display=swap';
    document.head.appendChild(l);
  };

  RosselleWidget.prototype._mount = function () {
    var root = document.createElement('div');
    root.id  = 'rosselle-widget';
    root.innerHTML = buildTemplate();
    document.body.appendChild(root);

    this.$fab      = document.getElementById('rw-fab');
    this.$window   = document.getElementById('rw-window');
    this.$body     = document.getElementById('rw-body');
    this.$textarea = document.getElementById('rw-textarea');
    this.$send     = document.getElementById('rw-send');
    this.$badge    = document.getElementById('rw-badge');
  };

  RosselleWidget.prototype._bind = function () {
    var self = this;
    this.$fab.addEventListener('click', function () { self.toggle(); });
    document.getElementById('rw-close-btn').addEventListener('click', function () { self.close(); });
    document.getElementById('rw-minimize').addEventListener('click', function () { self.toggleMinimize(); });
    this.$send.addEventListener('click', function () { self._send(); });
    this.$textarea.addEventListener('input', function () {
      self._resize();
      self.$send.disabled = !self.$textarea.value.trim();
    });
    this.$textarea.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        if (!self.$send.disabled) self._send();
      }
    });
  };

  /* ─── Open / Close ──────────────────────────────────────────── */
  RosselleWidget.prototype.toggle = function () {
    this.open ? this.close() : this.openChat();
  };

  RosselleWidget.prototype.openChat = function () {
    this.open      = true;
    this.minimized = false;
    this.$fab.classList.add('rw-fab--open');
    this.$window.classList.add('rw-window--open');
    this.$window.classList.remove('rw-window--minimized');
    this.$badge.style.display = 'none';
    this.$textarea.focus();
    if (!this.welcomed) { this.welcomed = true; this._showWelcome(); }
  };

  RosselleWidget.prototype.close = function () {
    this.open = false;
    this.$fab.classList.remove('rw-fab--open');
    this.$window.classList.remove('rw-window--open');
  };

  RosselleWidget.prototype.toggleMinimize = function () {
    this.minimized = !this.minimized;
    this.$window.classList.toggle('rw-window--minimized', this.minimized);
    if (!this.minimized) { this._scrollBottom(); this.$textarea.focus(); }
  };

  /* ─── Welcome ───────────────────────────────────────────────── */
  RosselleWidget.prototype._showWelcome = function () {
    var self = this;
    setTimeout(function () {
      self._addAiMessage(CFG.welcomeMessage);
      setTimeout(function () { self._addQuickReplies(CFG.quickReplies); }, 300);
    }, 400);
  };

  /* ─── Messages ──────────────────────────────────────────────── */
  RosselleWidget.prototype._addUserMessage = function (text) {
    var row = document.createElement('div');
    row.className = 'rw-row rw-row--user';
    row.innerHTML = [
      '<div class="rw-msg-avatar rw-msg-avatar--user">👤</div>',
      '<div class="rw-bubble-group">',
        '<div class="rw-bubble rw-bubble--user">' + escHtml(text) + '</div>',
        '<div class="rw-timestamp">' + fmtTime() + '</div>',
      '</div>'
    ].join('');
    this.$body.appendChild(row);
    this._scrollBottom();
  };

  RosselleWidget.prototype._addAiMessage = function (text, extra) {
    extra = extra || '';
    var row = document.createElement('div');
    row.className = 'rw-row rw-row--ai';
    row.innerHTML = [
      '<div class="rw-msg-avatar">RS</div>',
      '<div class="rw-bubble-group">',
        '<div class="rw-bubble rw-bubble--ai">' + renderMarkdown(text) + '</div>',
        extra,
        '<div class="rw-timestamp">' + fmtTime() + '</div>',
      '</div>'
    ].join('');
    this.$body.appendChild(row);
    this._scrollBottom();
    return row;
  };

  RosselleWidget.prototype._addQuickReplies = function (replies) {
    var self = this;
    var div  = document.createElement('div');
    div.className = 'rw-quick-replies';
    replies.forEach(function (r) {
      var btn = document.createElement('button');
      btn.className   = 'rw-qr';
      btn.textContent = r;
      btn.addEventListener('click', function () { div.remove(); self._submit(r); });
      div.appendChild(btn);
    });
    this.$body.appendChild(div);
    this._scrollBottom();
  };

  /* ─── Typing Indicator ──────────────────────────────────────── */
  RosselleWidget.prototype._showTyping = function () {
    if (document.getElementById('rw-typing')) return;
    var row = document.createElement('div');
    row.className = 'rw-typing';
    row.id = 'rw-typing';
    row.innerHTML = [
      '<div class="rw-msg-avatar">RS</div>',
      '<div class="rw-typing-bubble">',
        '<div class="rw-dot"></div>',
        '<div class="rw-dot"></div>',
        '<div class="rw-dot"></div>',
      '</div>'
    ].join('');
    this.$body.appendChild(row);
    this._scrollBottom();
  };

  RosselleWidget.prototype._hideTyping = function () {
    var el = document.getElementById('rw-typing');
    if (el) el.remove();
  };

  /* ─── Send ──────────────────────────────────────────────────── */
  RosselleWidget.prototype._send = function () {
    var txt = this.$textarea.value.trim();
    if (!txt) return;
    this._submit(txt);
  };

  RosselleWidget.prototype._submit = function (text) {
    if (!text || this.busy) return;
    if (!this.rl.check()) {
      this._addAiMessage('You\'re sending messages quite quickly. Please wait ' + this.rl.wait() + ' seconds.');
      return;
    }
    this.$textarea.value = '';
    this.$textarea.style.height = 'auto';
    this.$send.disabled = true;
    this._addUserMessage(text);
    this.session.history.push({ role: 'user', content: text });
    Session.save(this.session);
    this.busy = true;
    this._showTyping();
    var self = this;
    this._call(text)
      .then(function (data) { self._hideTyping(); self.busy = false; self._handleResponse(data); })
      .catch(function (err) { self._hideTyping(); self.busy = false; self._handleError(err); });
  };

  /* ─── Webhook ───────────────────────────────────────────────── */
  RosselleWidget.prototype._call = function (message) {
    if (!CFG.webhookUrl) return Promise.reject(new Error('ROSSELLE_WEBHOOK_URL not configured.'));
    var payload = {
      message:             message,
      sessionId:           this.session.id,
      conversationHistory: this.session.history.slice(-5),
      metadata: {
        timestamp: new Date().toISOString(),
        pageUrl:   typeof location !== 'undefined' ? location.href : '',
        customer:  global.ROSSELLE_CUSTOMER || null,
        pageCtx:   global.ROSSELLE_PAGE_CONTEXT || null
      }
    };
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, CFG.timeoutMs) : null;
    var opts = {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Widget-Token': CFG.widgetToken },
      body:    JSON.stringify(payload)
    };
    if (controller) opts.signal = controller.signal;
    return fetch(CFG.webhookUrl, opts).then(function (res) {
      if (timer) clearTimeout(timer);
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  };

  /* ─── Response Handler ──────────────────────────────────────── */
  RosselleWidget.prototype._handleResponse = function (data) {
    if (!data) { this._addAiMessage('I didn\'t receive a response. Please try again.'); return; }
    var msg   = data.message || data.text || data.output || '';
    var type  = data.type || 'text';
    var extra = '';
    if (type === 'product_list' && data.products && data.products.length) extra = renderProductCards(data.products);
    else if (type === 'escalation') extra = renderEscalation();
    if (msg || extra) {
      this._addAiMessage(msg || 'Here\'s what I found:', extra);
    } else if (typeof data === 'string') {
      this._addAiMessage(data);
    } else {
      this._addAiMessage('Is there anything else I can help you with?');
    }
    if (msg) { this.session.history.push({ role: 'assistant', content: msg }); Session.save(this.session); }
    if (data.quickReplies && data.quickReplies.length) {
      var self = this;
      setTimeout(function () { self._addQuickReplies(data.quickReplies); }, 250);
    }
  };

  RosselleWidget.prototype._handleError = function (err) {
    var msg;
    if (err && err.name === 'AbortError') {
      msg = 'The response took too long. Please try again.';
    } else if (typeof navigator !== 'undefined' && !navigator.onLine) {
      msg = 'You appear to be offline. Please check your connection.';
    } else if (err && err.message && err.message.indexOf('not configured') !== -1) {
      msg = 'The chat service is not set up yet. Please email ' + CFG.supportEmail + '.';
    } else {
      msg = 'Something went wrong. Please try again or email ' + CFG.supportEmail + '.';
    }
    this._addAiMessage(msg);
  };

  /* ─── Helpers ───────────────────────────────────────────────── */
  RosselleWidget.prototype._resize = function () {
    var t = this.$textarea;
    t.style.height = 'auto';
    t.style.height = Math.min(t.scrollHeight, 120) + 'px';
  };

  RosselleWidget.prototype._scrollBottom = function () {
    var b = this.$body;
    requestAnimationFrame(function () { b.scrollTop = b.scrollHeight; });
  };

  /* ─── Boot ──────────────────────────────────────────────────── */
  function boot() {
    if (global.__RosselleWidget) return;
    global.__RosselleWidget = new RosselleWidget();
    global.RosselleChat = {
      open:    function () { global.__RosselleWidget.openChat(); },
      close:   function () { global.__RosselleWidget.close(); },
      message: function (t) { global.__RosselleWidget._submit(t); }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

}(typeof window !== 'undefined' ? window : this));
